import React, { useState, useEffect } from "react";
import { StldPagination } from '../../styled-components/StyledPagination.style';
import { DynamicSelect } from '../../components/DynamicSelect';
import { DynamicInput } from "../../components/DynamicInput";
import { IconArrawSelectionRight, IconArrawSelectionLeft } from '../../svg';
import Select from 'react-select';

export const PaginationCustom = (props) => {
    let [maxRange, setMaxRange] = useState(0);
    let [minRange, setMinRange] = useState(0);
    let [pageRange, setPageRange] = useState(4);
    let [selectedValue, setSelectedValue] = useState({ label: '300', value: 300 });
    let [dPages, setDPages] = useState([]);
    let [currentPage, setCurrentPage] = useState(0);

    const pageOptions = [
        // { label: '10', value: 10 },
        // { label: '50', value: 50 },
        { label: '100', value: 100 },
        { label: '300', value: 300 },
        { label: '500', value: 500 },
        { label: '1000', value: 1000 },
        { label: 'Todos', value: 'all' }];

    useEffect(() => {

        //let totalPages = [];
        // let total = (props.recordsTotal / props.pageSize);
        // for (let i = 0; i < total; i++) {
        //     totalPages.push(i);
        // }
        // setDPages(totalPages);

        const startPage = Math.max(1, props.currentPage - pageRange);
        const endPage = Math.min(Math.ceil(props.recordsTotal / props.pageSize), props.currentPage + pageRange);

        const pages = [];
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        setDPages(pages);

        var selected = pageOptions.filter(f => f.value == props.pageSize)[0]
        if (selected) setSelectedValue({ ...selected });
    }, [props])

    const sendPagination = (i) => {
        setCurrentPage(i);
        props.setPage(i);

        const max = (selectedValue.value * i);
        const min = (max - selectedValue.value);

        setMinRange(min);
        setMaxRange(max);

        props.formData(null, min, max);
    }

    const previousPage = (currentPage) => {
        let previous = (currentPage - 1);
        if (previous > 0) {
            sendPagination(previous);
        }
    }

    const nextPage = (currentPage) => {
        let next = (currentPage + 1);

        const max = (selectedValue.value * next);
        const min = (max - selectedValue.value);

        if (min < props.recordsTotal) {
            sendPagination(next);
        }
    }

    const paramMethod = (currentValue) => {
        if (currentPage == "") {
            currentPage = 0;
        }

        // let totalPages = [];
        setMinRange(0);

        // for (let i = 0; i < Math.ceil(props.recordsTotal / currentValue.value); i++) {
        //     totalPages.push(i);
        // }


        const startPage = Math.max(1, currentPage - pageRange);
        const endPage = Math.min(Math.ceil(props.recordsTotal / currentValue.value), currentPage + pageRange);

        const pages = [];
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        setDPages(pages);
        setCurrentPage(currentPage);
        props.setPageSize(currentValue.value);
        props.formData(null, 0, currentValue.value);
    }

    return (
        (() => {
            if (props.isDesktop) {
                return (
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="position-relative" style={{ width: '10ch' }}>
                            <Select
                                className="basic-single"
                                key="pageSize"
                                value={selectedValue}
                                options={pageOptions}
                                onChange={paramMethod}
                            />
                        </div>
                        {/* <div className="position-relative col-sm-1 col-md-2 col-lg-2 p-2">
                            <DynamicInput type={'text'} placeholder={''} label={minRange + " - " + props.pageSize + " de " + props.recordsTotal} name={'totalRegistros'} />
                        </div> */}
                        <div className="position-relative col-sm-1 col-md-1 col-lg-1 p-2">
                            <StldPagination>
                                <div className="cursor-pointer" onClick={() => previousPage(props.currentPage)}>
                                    <IconArrawSelectionLeft />
                                </div>
                                {minRange !== 0 && <div className="cursor-pointer page px-1">...</div>}
                                {dPages.map((item, i) =>
                                    <div key={i} className={item === props.currentPage ? `highlight-page cursor-pointer page px-1` : `cursor-pointer page px-1`}
                                        onClick={() => sendPagination(item)}>{item}</div>)}
                                <div className="cursor-pointer" onClick={() => nextPage(props.currentPage)}>
                                    <IconArrawSelectionRight />
                                </div>
                            </StldPagination>
                        </div>
                    </div>
                )
            }
            return <div>
                <div className="position-relative col-sm-2 col-md-1 col-lg-1 p-2">
                    <Select
                        className="basic-single"
                        key="pageSize"
                        value={selectedValue}
                        options={pageOptions}
                        onChange={paramMethod}
                    />
                </div>
                <div className="position-relative col-sm-2 col-md-2 col-lg-2 p-2">
                    <DynamicInput type={'text'} placeholder={''} label={currentPage + " - " + props.pageSize + " de " + props.recordsTotal} name={'totalRegistros'} />
                </div>
                <div className="position-relative col-sm-2 col-md-1 col-lg-1 p-2">
                    <StldPagination>
                        <div className="cursor-pointer" onClick={() => previousPage(props.currentPage)}>
                            <IconArrawSelectionLeft />
                        </div>
                        {minRange !== 0 && <div className="cursor-pointer page px-1">...</div>}
                        {dPages.map((item, i) =>
                            <div key={i} className={item === props.currentPage ? `highlight-page cursor-pointer page px-1` : `cursor-pointer page px-1`}
                                onClick={() => sendPagination(item)}>{item}</div>)}
                        <div className="cursor-pointer" onClick={() => nextPage(props.currentPage)}>
                            <IconArrawSelectionRight />
                        </div>
                    </StldPagination>
                </div>
            </div>;
        })()
    )
}